import React from 'react';
import './Byline.css';

const Byline = ({ author, datePublished, dateModified, readingTime }) => {
  if (!author && !datePublished && !dateModified) return null;
  const name = author?.name || 'Irish Visa Tracker Team';
  const credentials = author?.credentials;

  return (
    <div className="byline">
      <div className="byline-author">
        <div className="byline-avatar" aria-hidden="true">
          {name
            .split(' ')
            .slice(0, 2)
            .map((part) => part[0])
            .join('')
            .toUpperCase()}
        </div>
        <div className="byline-meta">
          <div className="byline-name">
            By <strong>{name}</strong>
          </div>
          {credentials && <div className="byline-credentials">{credentials}</div>}
        </div>
      </div>
      <div className="byline-dates">
        {datePublished && (
          <span className="byline-pill" title="First published">
            Published {datePublished}
          </span>
        )}
        {dateModified && dateModified !== datePublished && (
          <span className="byline-pill byline-pill--fresh" title="Last reviewed">
            Updated {dateModified}
          </span>
        )}
        {readingTime && (
          <span className="byline-pill">{readingTime} min read</span>
        )}
      </div>
    </div>
  );
};

export default Byline;
